import { createContext } from 'react';

/**
 * Context for passing props to the SelectInputTriggerButton component.
 */
const SelectInputTriggerButtonPropsContext = /*#__PURE__*/createContext({});
/**
 * Context for providing the total count of items in a SelectInput.
 * Used for ARIA accessibility to inform screen readers about the total number of options.
 */
const SelectInputItemsCountContext = /*#__PURE__*/createContext(undefined);
/**
 * Context for providing the current item position in a SelectInput.
 * Used for ARIA accessibility to inform screen readers about the position of the option.
 */
const SelectInputItemPositionContext = /*#__PURE__*/createContext(undefined);
/**
 * Context indicating whether an option's content is rendered within the trigger button.
 * When true, certain styling adjustments are applied to make the content fit better in the trigger.
 */
const SelectInputOptionContentWithinTriggerContext = /*#__PURE__*/createContext(false);

export { SelectInputItemPositionContext, SelectInputItemsCountContext, SelectInputOptionContentWithinTriggerContext, SelectInputTriggerButtonPropsContext };
//# sourceMappingURL=SelectInput.contexts.mjs.map
